import type { HistoricalBetState, HistoricalSearchBetsQuery } from '../../types/historicalBets';

const betsRequested = (
  state: HistoricalBetState,
  payload: HistoricalSearchBetsQuery
): HistoricalBetState => ({
  ...state,
  bets: payload.pageNumber === 0 ? [] : state.bets,
  isFetching: true,
  isErroneous: false
});

export default betsRequested;
